export enum MeetingViewEnum {
  notes = "Notes",
  summary = "Summary",
  previousMeetingSummary = "Last Meeting Recap",
}
